<div class="modal-wrapper">
  <div class="overlay" *ngIf="showLoader">
    <app-spinner></app-spinner>
  </div>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ this.screenType === subsetDialogMode.RemoveFromSubset ? 'Remove From Subset' : 'Add To Subset' }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body ey-new-study-body">
    <div *ngIf="this.screenType === subsetDialogMode.AddToExistingSubset || this.screenType === subsetDialogMode.RemoveFromSubset">
      <div class="form-group subset-selection subset-field" [ngClass]="{ 'has-error': invalidSubset }">
        <span class="ey-float-label span-wide">
          <select class="form-control form-select" id="subset-name" name="subsetname" [(ngModel)]="this.subsetID" appLabelFloat>
            <option *ngFor="let subset of allSubsets" [ngValue]="subset.bdMatrixSubsetId">{{ subset.subsetName }}</option>
          </select>
          <label for="filterType">{{ this.screenType === subsetDialogMode.AddToExistingSubset ? 'Add to subset' : 'Remove from Subset' }}</label>
        </span>
      </div>
    </div>

    <div *ngIf="this.screenType === subsetDialogMode.AddNewSubset">
      <div class="form-group subset-field" [ngClass]="{ 'has-error': invalidSubset }">
        <span class="ey-float-label">
          <input
            type="text"
            class="form-control"
            id="subsetInput"
            name="subsetInput"
            [(ngModel)]="this.newSubsetName"
            #subsetInput="ngModel"
            maxlength="255"
            required
            appLabelFloat
          />
          <label for="newSubsetName">Create New Subset</label>
        </span>
      </div>
    </div>
    <span class="help-block" *ngIf="invalidSubset">
      {{ validationMessage }}
    </span>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <button class="btn btn-primary" (click)="saveSubset()">
      {{ this.screenType !== subsetDialogMode.RemoveFromSubset ? 'Add to subset' : 'Remove from Subset' }}
    </button>
  </div>
</div>
